// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d45008dc","703":"d071b023","787":"fc94faf7"}[chunkId] + ".chunk.js";
};